var map = {
	"./aaha_kasto_ramro_jutta.ogg": "./src/EGRContent/Story/RamailoMela/audios/aaha_kasto_ramro_jutta.ogg",
	"./birds.ogg": "./src/EGRContent/Story/RamailoMela/audios/birds.ogg",
	"./blank.ogg": "./src/EGRContent/Story/RamailoMela/audios/blank.ogg",
	"./busyMarket.ogg": "./src/EGRContent/Story/RamailoMela/audios/busyMarket.ogg",
	"./chito_khelna_aau.ogg": "./src/EGRContent/Story/RamailoMela/audios/chito_khelna_aau.ogg",
	"./cobler.ogg": "./src/EGRContent/Story/RamailoMela/audios/cobler.ogg",
	"./crowd.ogg": "./src/EGRContent/Story/RamailoMela/audios/crowd.ogg",
	"./damahaNJayali.ogg": "./src/EGRContent/Story/RamailoMela/audios/damahaNJayali.ogg",
	"./damahaOnly.ogg": "./src/EGRContent/Story/RamailoMela/audios/damahaOnly.ogg",
	"./dhanyebad.ogg": "./src/EGRContent/Story/RamailoMela/audios/dhanyebad.ogg",
	"./dhime.ogg": "./src/EGRContent/Story/RamailoMela/audios/dhime.ogg",
	"./dhobikhana1.ogg": "./src/EGRContent/Story/RamailoMela/audios/dhobikhana1.ogg",
	"./flute.ogg": "./src/EGRContent/Story/RamailoMela/audios/flute.ogg",
	"./horn.ogg": "./src/EGRContent/Story/RamailoMela/audios/horn.ogg",
	"./kehi_din.ogg": "./src/EGRContent/Story/RamailoMela/audios/kehi_din.ogg",
	"./ma_pani_pachi_kalakar.ogg": "./src/EGRContent/Story/RamailoMela/audios/ma_pani_pachi_kalakar.ogg",
	"./mela.ogg": "./src/EGRContent/Story/RamailoMela/audios/mela.ogg",
	"./naration.ogg": "./src/EGRContent/Story/RamailoMela/audios/naration.ogg",
	"./page1.ogg": "./src/EGRContent/Story/RamailoMela/audios/page1.ogg",
	"./page10.ogg": "./src/EGRContent/Story/RamailoMela/audios/page10.ogg",
	"./page12.ogg": "./src/EGRContent/Story/RamailoMela/audios/page12.ogg",
	"./page12a.ogg": "./src/EGRContent/Story/RamailoMela/audios/page12a.ogg",
	"./page3.ogg": "./src/EGRContent/Story/RamailoMela/audios/page3.ogg",
	"./page6.ogg": "./src/EGRContent/Story/RamailoMela/audios/page6.ogg",
	"./page8.ogg": "./src/EGRContent/Story/RamailoMela/audios/page8.ogg",
	"./panchebaja1.ogg": "./src/EGRContent/Story/RamailoMela/audios/panchebaja1.ogg",
	"./sarangi.ogg": "./src/EGRContent/Story/RamailoMela/audios/sarangi.ogg",
	"./sewing1.ogg": "./src/EGRContent/Story/RamailoMela/audios/sewing1.ogg",
	"./shenai.ogg": "./src/EGRContent/Story/RamailoMela/audios/shenai.ogg",
	"./sweeping.ogg": "./src/EGRContent/Story/RamailoMela/audios/sweeping.ogg",
	"./title.ogg": "./src/EGRContent/Story/RamailoMela/audios/title.ogg",
	"./woodwork1.ogg": "./src/EGRContent/Story/RamailoMela/audios/woodwork1.ogg",
	"./worshipbell1.ogg": "./src/EGRContent/Story/RamailoMela/audios/worshipbell1.ogg",
	"./worshipbell2.ogg": "./src/EGRContent/Story/RamailoMela/audios/worshipbell2.ogg",
	"./yo_raat_ko_lagi.ogg": "./src/EGRContent/Story/RamailoMela/audios/yo_raat_ko_lagi.ogg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/RamailoMela/audios sync recursive ^\\.\\/.*$";